import * as React from 'react';
import { myCameraStream } from 'state/video';
import { classNames } from 'utils/ui/css';
import { Stream } from 'utils/ui/media';
export interface IVideoProps {
  stream: Stream;
  // Stream control props
  autoStart?: boolean;
  audioMuted?: boolean;

  // Styling props
  className?: string;
  videoClassName?: string;

  // Event handlers
  onStreamStart?: (stream: Stream) => void;
  onStreamError?: (error: Error) => void;
  onStreamStop?: () => void;
}

export const Video: React.FC<IVideoProps> = ({
  stream,
  autoStart = true,
  audioMuted = false,
  className,
  videoClassName,
}) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const isMyOwnVideo = stream === myCameraStream().stream;

  const assignVideoSource = React.useCallback(async (): Promise<void> => {
    if (videoRef.current && stream) {
      if (typeof stream === 'string') {
        videoRef.current.src = stream;
      } else if (stream instanceof MediaStream) {
        videoRef.current.srcObject = stream;
      }
    } else if (videoRef.current && !stream) {
      // turn off video stream if no stream is provided (e.g. when video is toggled off)
      videoRef.current.srcObject = null;
    }
  }, [stream, videoRef]);

  React.useEffect(() => {
    if (autoStart) {
      assignVideoSource();
    }
  }, [autoStart, assignVideoSource]);

  return (
    <>
      <div className={classNames('ex3d-video', className)} part="video-container">
        <video
          ref={videoRef}
          className={classNames(videoClassName, '-scale-x-100')}
          muted={isMyOwnVideo || audioMuted}
          playsInline
          autoPlay
          controls={false}
        />
      </div>
    </>
  );
};
